export const getRandomKey = () => {
  return Math.random().toString(36).slice(2, 9);
};
